<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
      :showButtons="panel.showButtons">
      <div slot="content-main">
        <br>
        <div>
          <b-tabs v-model="tabIndex" lazy>
            <b-tab v-for="(t, i) in tabs" :key="i" :title="t.title">
              <component :is="t.comp" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";

import CategoryProduct from "./CategoryProduct.vue";
import Manufacturer from "./Manufacturer.vue";
import TypeProduct from "./TypeProduct.vue";
import UnitOfMeasurement from "./UnitOfMeasurement.vue";

import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ConfiguracaoStockView",
  components: {
    Panel,
    CategoryProduct,
    Manufacturer,
    TypeProduct,
    UnitOfMeasurement,
  },
  data() {
    return {
      tabIndex: 0,
      tabs: [
        { title: "Categoria", comp: CategoryProduct },
        { title: "Fabricante", comp: Manufacturer },
        { title: "Tipo", comp: TypeProduct },
        { title: "Unidade de Medida", comp: UnitOfMeasurement },
      ],
      panel: {
        module: "Estoque",
        title: "Configuração",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  created() {
    const saved = this.get_FilterStorage(this.$route.name);
    this.tabIndex =
      saved && typeof saved.tabIndex === "number" ? saved.tabIndex : this.tabIndex;
    this._addFilterStorage({ routeName: this.$route.name, tabIndex: this.tabIndex });
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  watch: {
    tabIndex(val) {
      this._addFilterStorage({ routeName: this.$route.name, tabIndex: val });
    },
  },
  computed: {
    ...mapGetters("generic", ["get_FilterStorage"]),
  },
  methods: {
    ...mapMutations("generic", ["_addFilterStorage", "removeLoading"]),
  },
};
</script>
